


import axiosInstance from '../../config';

export const loginService = async (data) => {

  try {


    const response = await axiosInstance.post('/v1/login', data)


    return {
      success: true,
      data: response.data,
      status: response.status,

    };


  }
  catch (error) {

    return {
      success: false,
      message: error.response?.data?.message || "Login failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,


    };

  }


}



